<template>
  <div class="form">
    <v-row>
      <v-col align="center" class="buttons-row">
        <DxButton
          class="tsid-login-button"
          text="ACCEDI TRAMITE TEAMSYSTEM ID"
          type="normal"
          styling-mode="text"
          @click="onTSIDDirectClick($event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DxButton from 'devextreme-vue/button'

export default {
  name: 'TsidDirectLogin',
  components: {
    DxButton,
  },
  data: () => ({
    userId: 0,
  }),
  mounted() {
    this.userId = localStorage.getItem('UserID')
  },
  methods: {
    onTSIDDirectClick() {
      const tsidRedirectUri = window.websiteConfig.tsidRedirectUri
      const tsidClientId = window.websiteConfig.tsidClientId
      const tsidAuthorizeUri = window.websiteConfig.tsidAuthorizeUri
      const locationHref =
        tsidAuthorizeUri +
        '?response_type=code&client_id=' +
        tsidClientId +
        '&redirect_uri=' +
        tsidRedirectUri +
        '&scope=openid'
      window.open(locationHref, '_self')
    },
  },
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.buttons-row {
  display: flex;
  justify-content: center;
  /* max-width: 55%;
  margin: 1rem 0 1rem 0; */
}
.dx-button.dx-button-normal.dx-state-disabled {
  background-color: darkgray !important;
}
.dx-button.dx-button-normal {
  margin-left: 1.5rem;
}
</style>
<style>
.hidden-row {
  visibility: hidden !important;
}
.dx-texteditor-input {
  margin: 0 !important;
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.87) !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -webkit-appearance: none !important;
  outline: 0 !important;
  border: 0 !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}
.dx-field-label {
  text-align: center;
}
</style>
